import {documenter} from './doc.js'; 
import TidalDoc from './TidalDoc.js';

export const standard = documenter();

standard(
    "Arpeggiator",
    [[0,5,7]]);
    
standard(
    "Beat Repeat",
    [0,,,0,,0]);

standard(
    "Midi Delay",
    [0,,,0,,0],
    (e) => {
        e.delayTime = 6;
        e.repeatsParameter.set(4);
    }
);

standard(
    "Every",
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    (e) => {
        let p = e.newParameter();
        p.parameter = e.track.trackData.transposeParameter;
        p.offset = 5;
        e.every = 3;
    }
);

standard(
    "Harmony",
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    (e) => {
        e.pitchParameter.set(-24);
        e.velocityParameter.set(0.11);
    }
);

standard(
    "Midi CC",
    [0]);

standard(
    "Parameterizer",
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    (e) => {
        e.parameter = e.track.trackData.transposeParameter;
        e.offset = 24;
        e.probability = 50;
    }
);

standard(
    "Scale",
    [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
);

standard("Tidal", [0], undefined, undefined, TidalDoc);

standard(
    "Timing",
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    (e) => e.oddOffset = 0.6);

standard(
    "User Script",
    [0,0,0,0,0,0,0,0,0,0,0,0,0],
    (e) => e.eval("alt(\n    vel(0.1),\n    chop(\n        randomSelect(range(16,0,8))))"));

standard(
    "Warp",
    [0],
    (e) => e.loopLength = 48.7);

export const flow = documenter();

flow(
    "Alternate",
    [0,,0,,0,,0,,0,0,0,0,0,0],
    undefined,
    {
        "in": "Alternate",
        "Alternate": ["Midi Delay", "Harmony"],
        "Harmony": "out",
        "Midi Delay": "out"
    }

);

flow(
    "Alternate N",
    [0,,0,,0,,0,,0,0,0,0,0,0],
    undefined,
    {
        "in": "Alternate N",
        "Alternate N": ["Midi Delay", "Harmony"],
        "Harmony": "out",
        "Midi Delay": "out"
    }
);

flow(
    "Beat",
    [0,,0,,0,,0,,0,0,0,0,0,0],
    undefined,
    {
        "in": "Beat",
        "Beat": ["Midi Delay", "Harmony"],
        "Harmony": "out",
        "Midi Delay": "out"
    }
);

flow(
    "Density",
    [0,0,0,0,0,0,0,0,,,,,,,0,],
    undefined,
    {
        "in": "Density",
        "Density": ["Midi Delay", "Harmony"],
        "Harmony": "out",
        "Midi Delay": "out"
    }
);

flow(
    "Limit",
    [0,0,0,0,0,0,0,0,,,,,,,0,],
    undefined,
    {
        "in": "Harmony",
        "Harmony": ["Limit"],
        "Limit": "out"
    }
);

flow(
    "Midi Outputter",
    [0,0,0,0,0,0,0,0,,,,,,,0,],
    undefined,
    {
        "in": "Midi Outputter",
        "Midi Outputter": "out"
    }
);

flow(
    "Pattern Switch",
    [0,0,0,0,0,0,0,0,,,,,,,0,],
    undefined,
    {
        "in": "Pattern Switch",
        "Pattern Switch": "out"
    }
);

flow(
    "Poly",
    [0,0,0,0,0,0,0,0,,,,,,,0,],
    undefined,
    {
        "in": "Harmony",
        "Harmony": "Poly",
        "Poly": ["Midi Delay", "Warp"],
        "Warp": "out",
        "Midi Delay": "out"
    }
);

flow(
    "Roll",
    [0,0,0,0,0,0,0,0,,,,,,,0,],
    undefined,
    {
        "in": "Roll",
        "Roll": ["Midi Delay", "Warp"],
        "Warp": "out",
        "Midi Delay": "out"
    }
);

flow(
    "Threshold",
    [0,,,,,,,0,,,,,,,0,],
    undefined,
    {
        "in": "Warp",
        "Warp": "Threshold",
        "Threshold": ["out", "Harmony"],
        "Harmony": "out"
    }
);
